export default {
	state: () => ({
		orderResult: {
			isError: false,
			messageError: '',
			purchaseReference: ''
		},
		panels: {
			panel1disabled: false,
			panel2disabled: false,
			panel3disabled: false,
			panel4disabled: false
		},
		activePanel: ''
	}),
	mutations: {
		SET_ORDER_RESULT(state, orderResult = {}) {
			state.orderResult = orderResult;
		},
		SET_PANEL_DISABLED(state, panels = {}) {
			state.panels = panels;
		},
		SET_ACTIVE_PANEL(state, activePanel) {
			state.activePanel = activePanel;
		}
	},
	actions: {
		SET_ORDER_RESULT({ commit }, payload = {}) {
			return commit('SET_ORDER_RESULT', payload);
		},
		SET_PANEL_DISABLED({ commit }, payload = {}) {
			return commit('SET_PANEL_DISABLED', payload);
		},
		SET_ACTIVE_PANEL({ commit }, payload) {
			return commit('SET_ACTIVE_PANEL', payload);
		}
	},
	getters: {
		getOrderResult: (state) => state.orderResult,
		getPanels: (state) => state.panels,
		getActivePanel: (state) => state.activePanel,
	}
};
